import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { useFeatureToggles } from '@grandvisionhq/state';
import { Containers } from '@grandvisionhq/stores-v2';

const StoreFinderSearchForm = ({ labels , appointmentTypeId , storeQueryFilter , shouldFilterServicesNotAvailableAppointmentsAtStore =true ,  })=>{
    const { isStoreFiltersEnabled  } = useFeatureToggles();
    const StoreSearchFormComponent = isStoreFiltersEnabled ? Containers.StoreSearchFormV2 : Containers.StoreSearchForm;
    return /*#__PURE__*/ React.createElement("div", {
        className: "appointments-store-finder-search-form"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest"
    }, labels.title), /*#__PURE__*/ React.createElement(StoreSearchFormComponent, {
        appointmentTypeId: appointmentTypeId,
        storeQueryFilter: storeQueryFilter,
        shouldFilterServicesNotAvailableAppointmentsAtStore: shouldFilterServicesNotAvailableAppointmentsAtStore
    }));
};

export { StoreFinderSearchForm as default };
//# sourceMappingURL=StoreFinderSearchForm.js.map
